import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { deleteBusinessFromAPI, fetchBusinessFromAPI } from "../../../services/BusinessService";


export const fetchBusiness = createAsyncThunk(
  "business/fetchBusiness",
  async ({ page, perPage, search }, { rejectWithValue }) => {
    try {
      const response = await fetchBusinessFromAPI(page, perPage, search);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Gagal mengambil data pengguna");
    }
  }
);


export const deleteBusiness = createAsyncThunk(
  "business/deleteBusiness",
  async (businessId, { rejectWithValue }) => {
    try {
      const response = await deleteBusinessFromAPI(businessId);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Gagal menghapus data pengguna");
    }
  }
);



const businessSlice = createSlice({
  name: "business",
  initialState: {
    business: [],
    currentPage: 1,
    lastPage: 1,
    perPage: 10,
    firstItem: 1,
    businessSearch: "",
    loading: false,
    error: null,
    totalCount:0,
    keywordSearch:""
  },
  reducers: {
    setSearchBusiness: (state, action) => {
      state.businessSearch = action.payload;
    },
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setVisibilityFilter: (state, action) => {
      state.currentFilter = action.payload;
    },
    setPerPage: (state, action) => {
      state.perPage = action.payload;
    },
    setKeywordSearch: (state, action) => {
      state.keywordSearch = action.payload;
    },
    resetBusinessState: (state) => {
      state.business = [];
      state.currentPage = 1;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBusiness.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBusiness.fulfilled, (state, action) => {
        state.loading = false;
        state.business = action.payload.data;
        state.currentPage = action.payload.meta.current_page;
        state.lastPage = action.payload.meta.last_page;
        state.perPage = action.payload.meta.per_page;
        state.firstItem = action.payload.meta.from; // ✅ Ambil `from` dari API
        state.totalCount = action.payload.meta.total;
      })
      .addCase(fetchBusiness.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteBusiness.fulfilled, (state, action) => {
        state.business = state.business.filter(business => business.id !== action.payload);
      })
      .addCase(deleteBusiness.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { setSearchBusiness, setPage, setVisibilityFilter, setPerPage, setKeywordSearch, resetBusinessState } = businessSlice.actions;
export default businessSlice.reducer;
